module.exports = __webpack_public_path__ + "img/search-black.c2296504.svg";